import type { PersonalBill, PersonalIncome } from './api/team.js';
import { INCOME_CATEGORY_LABEL } from './api/team.js';

/**
 * Planilha do Dinheiro (CSV para Excel e Planilhas em português): ponto e vírgula
 * entre colunas, vírgula nos centavos e marca UTF-8 no começo para os acentos.
 */
const HEADER = ['Mês', 'Tipo', 'Nome', 'Categoria', 'Rótulo', 'Valor (R$)', 'Data', 'Situação'];

const INCOME_STATUS: Record<PersonalIncome['status'], string> = {
  received: 'Recebido',
  expected: 'Previsto',
  skipped: 'Não veio',
};

function cell(value: string): string {
  // Nada que comece como fórmula vira fórmula na planilha.
  const safe = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[;"\n\r]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

const reais = (cents: number) => (cents / 100).toFixed(2).replace('.', ',');
const brDate = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;

export function moneyCsv(
  bills: PersonalBill[],
  incomes: PersonalIncome[],
  months: string[],
): string {
  const wanted = new Set(months);
  const rows: { month: string; date: string; line: string[] }[] = [];
  for (const item of incomes) {
    const month = item.date.slice(0, 7);
    if (!wanted.has(month)) continue;
    rows.push({
      month,
      date: item.date,
      line: [
        month,
        'Ganho',
        item.title,
        INCOME_CATEGORY_LABEL[item.category] ?? 'Outros',
        item.label ?? '',
        reais(item.amountCents),
        brDate(item.date),
        INCOME_STATUS[item.status] ?? '',
      ],
    });
  }
  for (const bill of bills) {
    const month = bill.dueDate.slice(0, 7);
    if (!wanted.has(month)) continue;
    rows.push({
      month,
      date: bill.dueDate,
      line: [
        month,
        'Conta',
        bill.title,
        '',
        '',
        reais(bill.amountCents),
        brDate(bill.dueDate),
        bill.status === 'paid' ? 'Paga' : 'A pagar',
      ],
    });
  }
  rows.sort((a, b) => a.date.localeCompare(b.date) || a.line[1]!.localeCompare(b.line[1]!));
  const body = [HEADER, ...rows.map((row) => row.line)]
    .map((line) => line.map(cell).join(';'))
    .join('\r\n');
  return `\ufeff${body}\r\n`;
}
